import { useEffect } from "react"

/**
 * Keyboard shortcuts: Cmd/Ctrl + 1/2/3 to switch lenses.
 */
export default function useKeyboardShortcuts(setActiveLens) {
  useEffect(() => {
    const handler = (e) => {
      const isCmdOrCtrl = e.metaKey || e.ctrlKey
      if (!isCmdOrCtrl) return

      const lensByKey = { "1": "domain", "2": "behavior", "3": "data" }
      const next = lensByKey[e.key]
      if (!next) return

      e.preventDefault()
      setActiveLens(next)
    }

    window.addEventListener("keydown", handler)
    return () => window.removeEventListener("keydown", handler)
  }, [setActiveLens])
}
